var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadGpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7222 19.4211H2.27778C1.80628 19.4211 1.3541 19.2104 1.0207 18.8354C0.687301 18.4603 0.5 17.9516 0.5 17.4211V3.42114C0.5 2.89071 0.687301 2.382 1.0207 2.00693C1.3541 1.63186 1.80628 1.42114 2.27778 1.42114H11.1574C11.7287 1.42114 12.2727 1.66544 12.6522 2.09241L15.9948 5.85281C16.3202 6.21892 16.5 6.69171 16.5 7.18154V17.4211C16.5 17.9516 16.3127 18.4603 15.9793 18.8354C15.6459 19.2104 15.1937 19.4211 14.7222 19.4211Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9446 19.4211V13.4211C12.9446 12.3166 12.0491 11.4211 10.9446 11.4211H6.05566C4.95109 11.4211 4.05566 12.3166 4.05566 13.4211V19.4211",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05566 1.42114V4.42114C4.05566 5.52571 4.95109 6.42114 6.05566 6.42114H11.1668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGpt);
export default __webpack_public_path__ + "static/media/download_gpt.8612aa817a61b6efa7ed35f61867f503.svg";
export { ForwardRef as ReactComponent };